import {TranslationObject} from '@colonist/i18n'
import {ViewPopup} from './ViewPopup'
import {setElementOnClick} from '../ui_utils/DomUtils'
import {AudioManager, AudioType} from '@colonist/audio'

export class ViewPopupStoreLink extends ViewPopup {
    private static readonly colorStoreLink = '/store#colors'

    constructor(title: TranslationObject, body: TranslationObject) {
        super(title, body, () => undefined, () => undefined, true)

        this.checkButton.id = 'store-href'
        setElementOnClick(this.checkButton, () => {
            AudioManager.play(AudioType.Click)
            this.removePopup()
            ViewPopupStoreLink.openStoreLink()
        })
        this.show()
    }

    private static openStoreLink() {
        const link = document.createElement('a')
        link.href = ViewPopupStoreLink.colorStoreLink
        link.target = '_blank'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
}
